export const MOBILE_SLIDER_PAGES_IDS = {
    ACCOUNT_STAT: 'stat',
    ASSET: 'asset',
    ASSETS: 'assets',
    DEPOSIT: 'deposit',
    DEPOSIT_SURVEY: 'deposit-survey',
    EMAIL_CONFIRMED: 'email-confirmed',
    HISTORY: 'history',
    HISTORY_INFO: 'history-info',
    OPEN_MOBILE_APP: 'open-mobile-app',
    POSITION_CREATE: 'create',
    POSITION_INFO: 'position',
    POSITION_UPDATE: 'position-update',
    REGISTER_EMAIL_CHECK: 'register-email-check',
    RESPAWN: 'respawn',
    SETTINGS: 'settings',
    VERIFY: 'verify',
    WITHDRAW: 'withdraw',
    WITHDRAWAL_REQUEST_SENT: 'withdrawal-request-sent',
}
